import { render, staticRenderFns } from "./ProductHome.vue?vue&type=template&id=093b8732&scoped=true&"
import script from "./ProductHome.vue?vue&type=script&lang=js&"
export * from "./ProductHome.vue?vue&type=script&lang=js&"
import style0 from "./ProductHome.vue?vue&type=style&index=0&id=093b8732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b8732",
  null
  
)

export default component.exports